// Директор видит отчёты, студентов и справочники как Система, но только на чтение:
// без кнопок изменения и без интеграций.
export const isReadOnlyDirector = (roles?: string[] | null): boolean =>
  !!roles && roles.includes("ROLE_DIRECTOR");
